import  { type RefUser,roles, type User } from "../../types/Users";
import { useAuth } from "../../contexts/auth/useAuth";
import ProfilDisplay from "../Common/ProfilDisplay";
import { useTrads } from "../../contexts/trads/useTrads";
import { useEffect, useState } from "react";
import { useLookupUsersQuery, useUpdateFondMutation } from "../../stores/OkOkStore";
import type { Fond } from "../../types/Fond";
interface UserGeneratedEntity {
    id:number,
    id_inscription: number,
    inscription?:RefUser

}
interface UserGeneratedProp{
    component:UserGeneratedEntity
}
function UserGenerated({component}:UserGeneratedProp){
    const {translate}=useTrads();
    const {hasRole} = useAuth();
    const [toggled,setToggled]=useState<boolean>(false);
    const{ data, error, isLoading } = useLookupUsersQuery({});

    const [user,setUser]=useState<RefUser>(component.inscription??{id:0})

    const [updateFond,result]=useUpdateFondMutation();
    const [value,setValue]=useState(component.inscription?.id??0);
    function toggleEditor(){
        setToggled(!toggled);
    }
    function handleChange(e:React.ChangeEvent<HTMLSelectElement>) {
        setValue(parseInt(e.currentTarget.value));
    }
    function SaveUser(){
        const fond: Partial<Fond> & Pick<Fond,'id'> ={id:component.id ,id_inscription:value}
        void updateFond(fond);
    }

    useEffect(()=>{
        console.log(result);
        if(result.isSuccess){
            if(result.data.inscription){
                setUser(result.data.inscription);
            }
            new Promise( res => setTimeout(res, 1000) ).then(()=>{
                result.reset();
                setToggled(false);
            }).catch(()=>{console.log('error timeout?')});
            
        }
    },[setUser, result, value])
    return(
    <>
        {component.inscription?
        <ProfilDisplay inscription={user} />
        :user.id}
        {hasRole(roles.Administrators)?

        <>
        <a onClick={toggleEditor}>{translate('update_owner')}</a>
        {toggled?

            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

                ) : isLoading ? (
                    <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
                ) : data ? (

                    
            <div>

                {result.isSuccess ? <p className="p-3 mb-2 bg-success text-white">{translate('msg_fond_update')}</p>  :
                result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :null}
                {result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
                    <>

                    <select onChange={handleChange} defaultValue={value}>
                        <option value="0">-----</option>
                        {data.data.map((e:User)=>(
                            <option key={e.id} value={e.id}>{e.identifiant}</option>
                        ))}
                    </select>
                    <button onClick={SaveUser}>{translate("save")}</button>
                    </>
                }
            </div>
                )
            :null
        :null}

        </>
        :null}      
    </>
    );
}
export default UserGenerated;